module.exports = __webpack_public_path__ + "img/slogan_pc.9809d57f.png";